<template>
  <div>
    <v-sparkline
      :value="value"
      :gradient="gradient"
      :smooth="radius || false"
      :padding="padding"
      :line-width="lineWidth"
      :stroke-linecap="lineCap"
      :gradient-direction="gradientDirection"
      :fill="fill"
      :type="type"
      :auto-line-width="autoLineWidth"
      auto-draw
      :show-labels="showLabels"
      :label-size="labelSize"
      :height="55"
    />
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

import { format, startOfMonth } from 'date-fns'
import Moment from 'moment'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)
const datetime_range = (start, end) => moment.range(moment(start, 'YYYY-MM-D HH:mm:ss'), moment(end, 'YYYY-MM-D HH:mm:ss'))

export default {
  mixins: [ appdata, utils ],
  data () {
    return {
      showLabels: false,
      lineWidth: 2.7,
      height: 20,
      labelSize: 7,
      radius: 10,
      padding: 0,
      lineCap: 'round',
      smooth: true,
      gradient: ['#e65c00', '#F9D423'],
      value: this.data,
      gradientDirection: 'bottom',
      fill: true,
      type: 'trend',
      autoLineWidth: false
    }
  },
  computed: {
    data () {
      this.get_data
      let now = new Date(),
          start = format(startOfMonth(now), 'yyyy-MM-dd'),
          end = format(now, 'yyyy-MM-dd'),
          days = Array.from(
              datetime_range(start, end).by('days', { step: 1 })
            ).map(rng => rng.format('YYYY-MM-DD'))
      return days.map(day => {
        let orders = (this.get_data.orders || []).filter(ord => this.formatDate(ord.datetime, false) === this.formatDate(day, false))
        return orders.length + 1
      })
    }
  },
  watch: {
    get_data: {
      deep: true,
      handler () {
        this.value = this.data
      }
    }
  },
  created () {
    this.value = this.data
  }
}
</script>

<style lang="scss">
#app .mini-spark-label {
  position: absolute;
  top: -15px;
}
</style>
